import React from 'react'
import PropTypes from 'prop-types'
import { map } from 'ramda'
import strings from 'utils/strings'
import { Button } from 'components/patterns'

const SELECT_PTO_MODE = 'SELECT_PTO_MODE'

const PtoSelectTemplateActionButtons = ({ handleDrawerAndClearTemplate }) => {
  const applyTemplateButtons = {
    [SELECT_PTO_MODE]: [
      {
        onClick: handleDrawerAndClearTemplate,
        type: 'secondary',
        disabled: false,
        text: strings.cancel,
      },
    ],
  }

  const renderButtons = map((buttonProps) => {
    const { text, ...rest } = buttonProps
    return (
      <Button key={text} {...rest}>
        {text}
      </Button>
    )
  })

  return renderButtons(applyTemplateButtons[SELECT_PTO_MODE])
}

PtoSelectTemplateActionButtons.propTypes = {
  handleDrawerAndClearTemplate: PropTypes.func,
}

export default PtoSelectTemplateActionButtons
